// extracted by mini-css-extract-plugin
export default {"grid":"Qr5DkL","container":"gT55_0"};